import React, { ReactNode, useState } from "react";
import StyledSpinner from "./StyledSpinner";
import clsx from "clsx";

interface StyledButtonProps {
  children: ReactNode;
  onClick: () => void;
  mode?: "primary" | "secondary" | "tertiary" | "quaternary";
  disabled?: boolean;
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
}

const StyledButton: React.FC<StyledButtonProps> = ({
  children,
  onClick,
  mode = "primary",
  disabled = false,
  className,
}: StyledButtonProps) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    try {
      setLoading(true);
      await onClick();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const classNameButton = () => {
    switch (mode) {
      case "primary":
        return "w-full rounded-xl bg-blue-600 px-4 py-2 text-white transition-colors duration-300 ease-in-out hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500";
      case "secondary":
        return "w-full rounded-xl px-4 py-2 font-semibold text-blue-600 focus:outline-hidden";
      case "tertiary":
        return "self-center rounded-xl bg-blue-50 px-4 py-2 font-semibold text-blue-600 focus:outline-hidden";
      case "quaternary":
        return "w-full rounded-xl border border-gray-300 px-4 py-2 font-semibold focus:outline-hidden";
      default:
        return "rounded-xl bg-blue-600 px-4 py-2 text-white transition-colors duration-300 ease-in-out hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500";
    }
  };

  return (
    <button
      disabled={disabled}
      className={clsx(classNameButton(), className)}
      onClick={handleClick}
    >
      {loading ? <StyledSpinner /> : children}
    </button>
  );
};

export default StyledButton;
